import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string, title: string, canCancel: boolean, actions: any }) { }

  ngOnInit(): void {
  }

  cancel(){
    this.dialogRef.close()
  }

  execute(action: () => void){
    action()
    this.dialogRef.close()
  }

}
